import React from "react";
import "./cta.css";

const CTA = () => {
  return (
    <div className="gpt3__cta section__margin section__padding">
      <div className="gpt3__cta-content">
        <p>Request Early Access to get Started</p>
        <h3>Register today & start enjoying the endless opportunities</h3>
      </div>
      <div className="gpt3__cta-btn">
        <button>Get Started</button>
      </div>
    </div>
  );
};

export default CTA;
